import React, { useState } from "react";
import firebase from "firebase/app";
import { useHistory } from "react-router-dom";
import Mensaje from "../../Mensaje";
import { v4 as uuidv4 } from "uuid";
import { dbApp } from "../../../firebase/config";

const AgregarProducto = () => {
  const [img, setImg] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [mensajeAdicional, setMensajeAdicional] = useState("");

  let history = useHistory();

  const STATE_INICIAL = {
    nombre: "",
    descripcion: "",
    ingredientes: "",
    images: "",
    adicionales: [],
    ubicacion: "",
    estatus: ""
  };

  const STATE_ADICIONAL_INICIAL = {
    id: "",
    tamanio: "",
    personas: "",
    precio: ""
  };

  const [datosForm, setDatosForm] = useState(STATE_INICIAL);
  const [datosAdicionales, setDatosAdicionales] = useState(
    STATE_ADICIONAL_INICIAL
  );

  const handleChange = e => {
    setDatosForm({
      ...datosForm,
      [e.target.name]: e.target.value.toUpperCase()
    });
  };
  const handleChangeAdicional = e => {
    setDatosAdicionales({
      ...datosAdicionales,
      [e.target.name]: e.target.value
    });
  };

  const agregarAdicionales = () => {
    setMensaje("");
    setMensajeAdicional("");

    if (
      datosAdicionales.tamanio === "" ||
      datosAdicionales.personas === "" ||
      datosAdicionales.precio === ""
    ) {
      setMensajeAdicional("Favor de agregar información adicional.");
    } else {
      datosAdicionales.id = uuidv4();
      datosForm.adicionales.push(datosAdicionales);
      setDatosAdicionales(STATE_ADICIONAL_INICIAL);
      console.log("object", datosForm);
    }
  };

  const handleUpload = event => {
    const file = event.target.files[0];
    const storeRef = firebase.storage().ref(`images/${file.name}`);
    const task = storeRef.put(file);

    task.on(
      "state_changed",
      snapshot => {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
      },
      error => {
        console.log("Ocurrio un error al subir las imagenes.");
      },
      () => {
        task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log("File available at", downloadURL);
          setImg(downloadURL);
          setDatosForm({
            ...datosForm,
            images: downloadURL
          });
        });
      }
    );
  };

  const hanldeSubmit = () => {
    setMensaje("");
    setMensajeAdicional("");
    console.log(datosForm);
    if (
      datosForm.nombre === "" ||
      datosForm.descripcion === "" ||
      datosForm.ingredientes === "" ||
      datosForm.ubicacion === ""
    ) {
      setMensaje("Favor de llenar la infomación.");
    } else if (datosForm.images === "") {
      setMensaje("Favor de seleccionar imagen del producto.");
    } else if (datosForm.adicionales.length <= 0) {
      setMensajeAdicional("Favor de agregar información adicional.");
    } else {
      dbApp
        .collection("pizzas")
        .add(datosForm)
        .then(response => {
          history.push("/admin/producto");
        })
        .catch(() => {
          console.log("Erro");
        });
    }
  };

  const handleDeleteAdicional = id => {
    //console.log(id);

    const copiaDataForm = datosForm;
    const nuevosAdicionales = copiaDataForm.adicionales.filter(
      adi => adi.id !== id
    );
    console.log("nuevosAdicionales", nuevosAdicionales);
    //copiaDataForm.adicionales = { nuevosAdicionales };
    setDatosForm({
      ...datosForm,
      adicionales: nuevosAdicionales
    });
    console.log("object---------", copiaDataForm);
    //setDatosForm(copiaDataForm);
    console.log("datosForm2", datosForm);
  };

  console.log("Gabo............. ", datosForm);

  return (
    <>
      <form>
        <div className="form-group">
          <label htmlFor="nombre">Nombre</label>
          <input
            type="text"
            className="form-control"
            id="nombre"
            name="nombre"
            value={datosForm.nombre}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="descripcion">Descripción</label>
          <input
            type="text"
            className="form-control"
            id="descripcion"
            name="descripcion"
            value={datosForm.descripcion}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="ingredientes">Ingredientes</label>
          <textarea
            className="form-control"
            id="ingredientes"
            name="ingredientes"
            value={datosForm.ingredientes}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="ubicacion">Ubicación</label>
          <select
            className="form-control"
            id="ubicacion"
            name="ubicacion"
            value={datosForm.ubicacion}
            onChange={handleChange}
          >
            <option>Selecciona...</option>
            <option>INICIO</option>
            <option>PRODUCTOS</option>
            <option>AMBOS</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="estatus">Estatus</label>
          <select
            className="form-control"
            id="estatus"
            name="estatus"
            value={datosForm.estatus}
            onChange={handleChange}
          >
            <option>Selecciona...</option>
            <option>ACTIVO</option>
            <option>INACTIVO</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="imagen">Imagen</label>
          <br />
          {img ? (
            <div className="w-100 mt-1 mb-1 border" style={{ height: "100px" }}>
              <img className="rounded w-50 h-100 border" src={img} alt="IMG" />
            </div>
          ) : null}
          <span className="btn btn-primary btn-file">
            <i className="fa fa-upload" aria-hidden="true"></i>
            <input
              type="file"
              id="images"
              name="images"
              multiple
              accept="image/*"
              onChange={handleUpload}
            />
          </span>
        </div>

        <h5 className="font-weight-bold text-center">Adicionales</h5>

        {datosForm.adicionales && datosForm.adicionales.length > 0 ? (
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col texto-centrado">Tamaño</th>
                <th scope="col texto-centrado">Personas</th>
                <th scope="col texto-centrado">Precio</th>
                <th scope="col texto-centrado">Opciones</th>
              </tr>
            </thead>
            <tbody>
              {datosForm.adicionales.map((adicional, index) => (
                <tr key={adicional.id}>
                  <td>{adicional.tamanio}</td>
                  <td>{adicional.personas}</td>
                  <td>{adicional.precio}</td>
                  <td className="d-flex justify-content-end">
                    <i
                      className="fa fa-trash-o text-danger fa-lg m-2"
                      aria-hidden="true"
                      onClick={() => handleDeleteAdicional(adicional.id)}
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}

        <div className="form-row border-bottom">
          <div className="form-group col-md-6">
            <label htmlFor="tamanio">Tamaño</label>
            <input
              type="text"
              className="form-control"
              id="tamanio"
              name="tamanio"
              value={datosAdicionales.tamanio}
              onChange={handleChangeAdicional}
            />
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="personas">Personas</label>
            <input
              type="text"
              className="form-control"
              id="personas"
              name="personas"
              value={datosAdicionales.personas}
              onChange={handleChangeAdicional}
            />
          </div>
          <div className="form-group col-md-2">
            <label htmlFor="precio">Precio</label>
            <input
              type="text"
              className="form-control"
              id="precio"
              name="precio"
              value={datosAdicionales.precio}
              onChange={handleChangeAdicional}
            />
          </div>

          <div className="col-12">
            <button
              type="button"
              className="btn bg-info mb-2 mt-1 text-white"
              onClick={agregarAdicionales}
            >
              <i className="fa fa-plus mr-1" aria-hidden="true"></i>Agregar
              Adicional
            </button>
          </div>

          {mensajeAdicional && (
            <div className="col-12">
              <Mensaje mensaje={mensajeAdicional} />
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-primary mr-2"
            onClick={hanldeSubmit}
          >
            <i className="fa fa-plus mr-1" aria-hidden="true"></i>
            Agregar Producto
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => history.goBack()}
          >
            <i className="fa fa-chevron-left mr-1" aria-hidden="true"></i>
            Cancelar
          </button>
        </div>

        {mensaje && (
          <div className="mt-2">
            <Mensaje mensaje={mensaje} />
          </div>
        )}
      </form>
    </>
  );
};

export default AgregarProducto;
